"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualRaise = AnnualRaise;
exports.CurrentAge = CurrentAge;
exports.CurrentContribution = CurrentContribution;
exports.EmployerMatchLimit = EmployerMatchLimit;
exports.EmployerMatchRate = EmployerMatchRate;
exports.EmployerMatchYN = EmployerMatchYN;
exports.FilingStatus = FilingStatus;
exports.PlanType = PlanType;
exports.RateOfReturn = RateOfReturn;
exports.RetTaxRate = RetTaxRate;
exports.RetirementAge = RetirementAge;
exports.Salary = Salary;
exports.State = State;
exports.TaxPreference = TaxPreference;
exports.TaxRate = TaxRate;
exports.WithdrawalAge = WithdrawalAge;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _TraditionalvRothWizardCalc = require("./TraditionalvRothWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CurrentAge(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'currentAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Current Age',
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: "This analysis assumes you will make your first contribution at your current age.",
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function Salary(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'salary';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Salary',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function AnnualRaise(_ref3) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'annualRaise';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = ' 0 ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Salary Growth Rate',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: "Represents the annual increase in salary you expect to receive each year up to retirement.",
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function RateOfReturn(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'rateOfReturn';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = ' 0 ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Rate of Return',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: "Represents the assumed rate of return on your savings.",
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function CurrentContribution(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'currentContribution';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = ' 0 ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'My Contribution Rate',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function EmployerMatchRate(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'employerMatchRate';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = ' 0 ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Employer Match',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function EmployerMatchLimit(_ref7) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref7;
  var fieldName = 'employerMatchLimit';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = ' 0 ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Employer Matching Contribution Limit',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function RetirementAge(_ref8) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref8;
  var fieldName = 'retAge';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Retirement Age",
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function WithdrawalAge(_ref9) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref9;
  var fieldName = 'withdrawalAge';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Withdrawal Age",
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}

// Dropdown inputs start here

function State(_ref10) {
  var {
    values,
    setFieldValue
  } = _ref10;
  var fieldName = 'state';
  var placeholderProp = 'Select your state';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.statesArray,
    fieldName: fieldName,
    label: 'State',
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    placeholderProp: placeholderProp,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.statesArray
  });
}
function TaxRate(_ref11) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref11;
  var fieldName = 'lastYearTaxRate';
  var placeholderProp = ' 0% ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    errors: errors,
    touched: touched,
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.lastYearTaxRatesArray,
    fieldName: fieldName,
    label: "Previous Year's Income Tax Rate",
    placeholderProp: placeholderProp,
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.lastYearTaxRatesArray
  });
}
function FilingStatus(_ref12) {
  var {
    values,
    setFieldValue
  } = _ref12;
  var fieldName = 'filingStatus';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.filingArray,
    fieldName: fieldName,
    label: 'Filing Status',
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.filingArray
  });
}
function TaxPreference(_ref13) {
  var {
    values,
    setFieldValue
  } = _ref13;
  var fieldName = 'preference';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.taxPreferencesArray,
    fieldName: fieldName,
    label: 'Tax Preference',
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.taxPreferencesArray
  });
}
function PlanType(_ref14) {
  var {
    values,
    setFieldValue
  } = _ref14;
  var fieldName = 'planType';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.planTypeArray,
    fieldName: fieldName,
    label: 'Sub-account Type',
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.planTypeArray
  });
}
function EmployerMatchYN(_ref15) {
  var {
    values,
    setFieldValue
  } = _ref15;
  var fieldName = 'employerMatchYN';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.employerMatchYNArray,
    fieldName: fieldName,
    label: 'Employer',
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.employerMatchYNArray
  });
}
function RetTaxRate(_ref16) {
  var {
    values,
    setFieldValue
  } = _ref16;
  var fieldName = 'retTaxRate';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.retTaxRateArray,
    fieldName: fieldName,
    label: 'Expected Tax Rate in Retirement',
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName,
    dataArray: _TraditionalvRothWizardCalc.dropdownOptions.retTaxRateArray
  });
}